import { createContext } from "preact";
import { useContext } from "preact/hooks";

import ReorderListData from "./ReorderListData";

interface ReorderListContext {
    showDragIcon?: boolean;
    onReorder: (reorderListData: ReorderListData) => void;
}

const ReorderListContext = createContext<ReorderListContext>({
    showDragIcon: false,
    onReorder: () => null
});

const useReorderListContext = () => useContext(ReorderListContext);

export default ReorderListContext;
export {
    useReorderListContext
};
